
export default {
    generateNumberOrder(numberOrder) {
        let numbreString = `${numberOrder}`
        const totalDigist = 6
        let newNumberOrder = numbreString
        for (let i = 0; i < (totalDigist - numbreString.length); i++) {
            newNumberOrder = '0' + newNumberOrder
        }
        return newNumberOrder
    },
    findIndexFromItem(data, idSearched) {
        let indexFounded = -1
        data.forEach( (element, index) => {
            if (element.id === idSearched) {
                indexFounded = index
            }
        })

        return indexFounded
    },
    getItemFromList(data, idSearched){
        let itemFounded = null
        data.forEach( (element, index) => {
            if (element.id === idSearched) {
                itemFounded = element
            }
        })

        return itemFounded
    },
    getNumberDecimalValue(number) {
        let value = 0
        if(!isNaN(number) && number !== null && number !== '') {
            value = parseFloat(number)
        }

        return value
    },
    getStatusProviderAccount(provider){
        let expiration = provider.date_agreement
        console.log(expiration)
        return 'Vencida'
    },
    getSumCash(data){
        let sum = 0
        data.forEach(element => {
            sum = sum + parseFloat(element.amount)
        })

        return sum
    },
    prepareCurrentDate(dateData = null) {
        if(dateData == null) {
            dateData = new Date();
        }
        let current = dateData;
        let year = current.getFullYear()
        let month = current.getMonth() + 1
        let day = current.getDate()

        if (month < 10) {
            month = '0' + month.toString()
        }

        if (day < 10) {
            day = '0' + day.toString()
        }

        let dateCurrent = year + '-' + month + '-' + day

        return dateCurrent
    },
    setFormatDate(dateData) {
        let dateFormatted = ''
        if (dateData != null) {
            let current = dateData;
            let year = current.getFullYear()
            let month = current.getMonth() + 1
            let day = current.getDate()

            if (month < 10) {
                month = '0' + month.toString()
            }

            if (day < 10) {
                day = '0' + day.toString()
            }

            dateFormatted = day + '/' + month + '/' + year
        }        

        return dateFormatted
    },

    generateBarcode () {
        this.length = 9;
        this.timestamp = +new Date;		 
        
        var ts = this.timestamp.toString();
        var parts = ts.split( "" ).reverse();
        var id = "";
        
        for( var i = 0; i < this.length; ++i ) {
            var index = this.getRandomInt( 0, parts.length - 1 );
            id += parts[index];	 
        }
        
        return id;
    },

    getRandomInt (min, max) {
        return Math.floor( Math.random() * ( max - min + 1 ) ) + min;
    },

    generateVariantsTree (variants) {
        let variant_tree = [];
        variants.forEach( element => {
            let children = [];
            let variant_options = element.options;
            for (let option of variant_options) {
                let childrenItem = {
                    id: option.id,
                    name: option.option_name
                }

                children.push(childrenItem);
            }

            let variantItem = {
                id: element.id + '-v',
                name: element.name,
                children: children
            };
            variant_tree.push(variantItem);
        });

        return variant_tree;
    },

    getElementById (data, search_id) {
        let itemFounded = null;
        data.forEach( element => {
            if (parseInt(element.id) == parseInt(search_id)) {
                itemFounded = Object.assign({}, element);
            }
        });

        return itemFounded;
    },

    existItemInArray (data, search_id) {
        let founded = false;
        data.forEach( (element) => {
            if (parseInt(element.id) == parseInt(search_id)) {
                founded = true;
            }
        });

        return founded;
    },

    generateVariantTableData (listVariants) {
        let list = [];
        let numberItems = listVariants.length - 1;
        let index = 0;
        for (let i = numberItems; i >= 0; i--) {
            index++;
            let variant = listVariants[i];
            let options = variant.options;            
            let ListTemp = [];
            for (let option of options) {
                index++;
                let key = variant.name.toLowerCase();
                let item = {};
                let today = new Date();
                item['id'] = today.getTime() + index;
                item[key] = option.option_name;
                item[key+'_id'] = option.id;
                item['row_id'] = option.id;
                item['description'] = option.option_name;
                item['barcode'] = this.generateBarcode();
                item['unit_price'] = 0;
                item['wholesale_price'] = 0;
                item['preferential_price'] = 0;
                if (list.length == 0) {
                    ListTemp.push(item);
                } else {
                    for (let row of list) {
                        index++;
                        let newRow = Object.assign({}, row);
                        let todayNew = new Date();
                        newRow['id'] = todayNew.getTime() + index;
                        newRow[key] = option.option_name;
                        newRow[key+'_id'] = option.id;
                        newRow['row_id'] = newRow['row_id'] + '_' + option.id;
                        newRow['description'] = option.option_name + ' / ' + newRow['description'];
                        newRow['barcode'] = this.generateBarcode();
                        newRow['unit_price'] = 0;
                        newRow['wholesale_price'] = 0;
                        newRow['preferential_price'] = 0;
                        ListTemp.push(newRow);
                    }
                }
            }            
            list = Object.assign([], ListTemp);
        }

        console.log(list);
        return list;
    }
}